import { render, staticRenderFns } from "./photoOverlay.vue?vue&type=template&id=b32f7b92&scoped=true"
import script from "./photoOverlay.vue?vue&type=script&lang=js"
export * from "./photoOverlay.vue?vue&type=script&lang=js"
import style0 from "./photoOverlay.vue?vue&type=style&index=0&id=b32f7b92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f7b92",
  null
  
)

export default component.exports